import SidebarComponent from './sidebar';
import { Styled } from './sidebar.styled';
import MenuItemComponent from './components/menu-item';

const Sidebar = {
    ...Styled,
    Layout: SidebarComponent,
    MenuItem: MenuItemComponent,
};

export { Sidebar };
